import Vue from "vue";

export default {
	extends: Vue,
	props: {
		field: String,
		dataItem: Object,
		format: String,
		className: String,
		columnIndex: Number,
		columnsCount: Number,
		rowType: String,
		level: Number,
		expanded: Boolean,
		editor: String,

		readonly: {type: Boolean, default: false},
		disabled: {type: Boolean, default: false}
	},
	methods: {
		removeHandler: function() {
			if (!this.readonly && !this.disabled) this.$emit("remove", {dataItem: this.dataItem});
		}
	}
};
